import ExpandableContainer from '../../ExpandableContainer'
import OrderByAvailableColumnsTable from './OrderByAvailableColumnsTable'
import AssignActions from '../table/AssignActions'
import OrderByColumnsTable from './OrderByColumnsTable'
import OrderByColumnsContextProvider from './OrderByColumnsContext'

const OrderByColumns = () => {
    return (
        <OrderByColumnsContextProvider>
            <ExpandableContainer
                title="Order By Columns"
                leftContent={<OrderByAvailableColumnsTable />}
                centerContent={<AssignActions mode="orderBy" />}
                rightContent={<OrderByColumnsTable />}
            >
            </ExpandableContainer>
        </OrderByColumnsContextProvider>
    )
}

export default OrderByColumns